module.exports = __webpack_public_path__ + "static/media/flip.93a17aa6.svg";